import Lottie from "lottie-react";
import soundWaves from "./SoundWaves.json";

interface LottieVoiceProps {
  listening: boolean;
  lottieRef: any;
}

const LottieVoice: React.FC<LottieVoiceProps> = ({ listening, lottieRef }) => {
  return (
    <Lottie animationData={soundWaves} loop={listening} lottieRef={lottieRef} />
  );
};

export default LottieVoice;
